import Team from 'app/developer-v3/pages/team';
import Members from 'app/developer-v3/pages/team/Members';
import Settings from 'app/developer-v3/pages/team/Settings';

import { stripTrailingSlash } from '@zapier/url-utils';

export default {
  component: Team,
  routes: {
    '.': {
      onEnter({ router, routeTo }) {
        routeTo(`${stripTrailingSlash(router.next.url)}/members`);
      },
    },
    members: Members,
    settings: Settings,
  },
};
